import styled from 'styled-components';

export const Container = styled.div`
  z-index: 0;
`;

export const Content = styled.div`
  display: flex;
  z-index: -1;
  width: 100%;
  margin-bottom: 0.5rem;
`;
